// @ts-strict-ignore
import React from 'react';

import { CtaHeroBlockData } from 'api/cms';
import { PublicPage } from 'api/website';
import { getContentPageUrl } from 'cms/helpers';
import { useHasGradProgram, useLoggedIn } from 'cms/hooks';
import { Box } from 'components/Box';
import { CallToActionButton, PrimaryButtonLink } from 'components/Button';
import Text, { H2, HeadingSmall } from 'components/Text';
import { gutterWidth } from 'theme';
import { imageUrl } from 'utils/filestack';

const getImageUrl = (handle: string, mimetype: string) =>
  imageUrl({
    handle,
    mimetype,
    transform: `resize=width:2096,fit:max/quality=value:70`,
  });

type Data = CtaHeroBlockData & {
  isGrad?: boolean;
  isEmailSignup?: boolean;
  isMap?: boolean;
  label?: string;
};

type Props = {
  content: PublicPage;
  data: Data;
  blockId: string;
};

export function AmpHeroBlock({
  content,
  data: {
    label,
    buttonText,
    buttonUrl,
    text,
    image,
    isGrad,
    isEmailSignup,
    isMap,
  },
  blockId,
}: Props) {
  const pageUrl = getContentPageUrl({ content });
  const loggedIn = useLoggedIn();
  const hasGradProgram = useHasGradProgram();

  return (
    <Box
      height={450}
      mx={[-gutterWidth / 2, null, -gutterWidth]}
      overflow="hidden"
      color="white"
      textAlign="center"
      borderRadius={[0, null, null, 48]}
      backgroundImage={`url(${
        // TODO: Fix this the next time the file is edited.
        // eslint-disable-next-line no-nested-ternary
        image && image.handle
          ? getImageUrl(image.handle, image.mimetype) // TODO: Fix this the next time the file is edited.
          : // eslint-disable-next-line no-nested-ternary
          isMap
          ? '/static/images/idealist-days-map.jpg'
          : isEmailSignup
          ? '/static/images/blue-loops.svg'
          : '/static/images/blue-loops.svg'
      })`}
      backgroundSize="cover"
    >
      <Box
        width={1}
        height="100%"
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        bg="rgba(0,0,0,0.35)"
        textAlign="center"
      >
        <Box maxWidth="768px" m="0 auto" px="20px">
          {label && <HeadingSmall>{label}</HeadingSmall>}
          {isMap ? (
            <Text
              dangerouslySetInnerHTML={{
                __html: text,
              }}
            />
          ) : (
            <H2>{text}</H2>
          )}
        </Box>
        {/* TODO: Fix this the next time the file is edited. */}
        {/* eslint-disable-next-line no-nested-ternary */}
        {buttonUrl && buttonText ? (
          <PrimaryButtonLink href={buttonUrl}>{buttonText}</PrimaryButtonLink>
        ) : isGrad ? (
          <CallToActionButton
            loggedIn={loggedIn}
            hasGradProgram={hasGradProgram}
          />
        ) : (
          buttonText && (
            <PrimaryButtonLink href={`/${pageUrl}#cms-block-${blockId}`}>
              {buttonText}
            </PrimaryButtonLink>
          )
        )}
      </Box>
    </Box>
  );
}
